/**
 * Utilizada para conversões em geral
 */
export class Conversion {

    /**
     * Converte base64 em blob
     * @param b64Data base64
     * @param contentType tipo de conteúdo
     * @param sliceSize lenght do base64
     */
    public static ConvertBase64toBlob(b64Data: any, contentType: string, sliceSize: number): any {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
}
